import React from 'react';
import { Link } from 'react-router-dom';
import HomeSection from './HomeSection';
import type { ProductUpdate } from './homeTypes';

interface ProductUpdatesProps {
  updates: ProductUpdate[];
}

export const ProductUpdates: React.FC<ProductUpdatesProps> = ({ updates }) => {
  const list = updates.slice(0, 3);
  if (!list.length) return null;

  return (
    <HomeSection title="Product updates" tone="muted">
      <ul className="space-y-4">
        {list.map((u) => (
          <li key={u.id} className="max-w-2xl">
            <h3 className="text-white font-medium text-sm sm:text-base">
              {u.href ? (
                <Link
                  to={u.href}
                  className="hover:text-orange-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-400 rounded"
                >
                  {u.title}
                </Link>
              ) : (
                u.title
              )}
            </h3>
            {u.body ? <p className="text-gray-400 text-sm mt-1 leading-relaxed">{u.body}</p> : null}
            {u.published_at ? (
              <time className="text-gray-600 text-xs mt-1 block" dateTime={u.published_at}>
                {new Date(u.published_at).toLocaleDateString()}
              </time>
            ) : null}
          </li>
        ))}
      </ul>
    </HomeSection>
  );
};

export default ProductUpdates;
